import { defineMessages } from "react-intl";

export const LogMessageType = {
  roomEntryRequired: "roomEntryRequired",
  flyModeDisabled: "flyModeDisabled",
  flyModeEnabled: "flyModeEnabled",
  unauthorizedSceneChange: "unauthorizedSceneChange",
  invalidSceneUrl: "invalidSceneUrl",
  unauthorizedRoomRename: "unauthorizedRoomRename",
  captureUnavailable: "captureUnavailable",
  captureStopped: "captureStopped",
  captureStarted: "captureStarted",
  captureAlreadyStopped: "captureAlreadyStopped",
  captureAlreadyRunning: "captureAlreadyRunning",
  positionalAudioEnabled: "positionalAudioEnabled",
  positionalAudioDisabled: "positionalAudioDisabled",
  setAudioNormalizationFactor: "setAudioNormalizationFactor",
  audioNormalizationDisabled: "audioNormalizationDisabled",
  audioNormalizationNaN: "audioNormalizationNaN",
  invalidAudioNormalizationRange: "invalidAudioNormalizationRange",
  audioSuspended: "audioSuspended",
  audioResumed: "audioResumed",
  joinFailed: "joinFailed",
  avatarChanged: "avatarChanged",
  handRaised: "handRaised",
  voiceChatEnabled: "voiceChatEnabled",
  voiceChatDisabled: "voiceChatDisabled",
  voiceChatDisabledMod: "voiceChatDisabledMod",
  textChatEnabled: "textChatEnabled",
  textChatDisabled: "textChatDisabled",
  textChatDisabledMod: "textChatDisabledMod",
  enteredVerse: "enteredVerse",
  leaveVerse: "leaveVerse",
  lobbyCast: "lobbyCast",
  recordModeEnabled: "recordModeEnabled",
  avatarCreated: "avatarCreated",
  assetRenamed: "assetRenamed",
  assetRenameFailed: "assetRenameFailed",
  assetUpdated: "assetUpdated",
  assetUpdateFailed: "assetUpdateFailed",
  assetDeleted: "assetDeleted",
  assetDeleteFailed: "assetDeleteFailed",
  assetOptimized: "assetOptimized",
  objectDeleted: "objectDeleted",
  objectCloned: "objectCloned",
  copied: "copied",
  objectFocusedDeleted: "objectFocusedDeleted",
  lobbyTip: "lobbyTip",
  safariMicTitle: "safariMicTitle",
  safariMicMessage: "safariMicMessage",
  displayNameChanged: "display_name_changed"
};

export const logMessages = defineMessages({
  [LogMessageType.roomEntryRequired]: {
    id: "chat-sidebar.log-message.room-entry-required",
    defaultMessage: "You must enter the Verse to use this command"
  },
  [LogMessageType.flyModeDisabled]: {
    id: "chat-sidebar.log-message.fly-mode-disabled",
    defaultMessage: "Fly mode disabled"
  },
  [LogMessageType.flyModeEnabled]: {
    id: "chat-sidebar.log-message.fly-mode-enabled",
    defaultMessage: "Fly mode enabled"
  },
  [LogMessageType.unauthorizedSceneChange]: {
    id: "chat-sidebar.log-message.unauthorized-scene-change",
    defaultMessage: "You do not have permission to change the scene"
  },
  [LogMessageType.invalidSceneUrl]: {
    id: "chat-sidebar.log-message.invalid-scene-url",
    defaultMessage: "This URL does not point to a scene or valid GLB"
  },
  [LogMessageType.unauthorizedRoomRename]: {
    id: "chat-sidebar.log-message.unauthorized-room-rename",
    defaultMessage: "You do not have permission to rename this room"
  },
  [LogMessageType.captureUnavailable]: {
    id: "chat-sidebar.log-message.capture-unavailable",
    defaultMessage: "Capture unavailable"
  },
  [LogMessageType.captureStopped]: {
    id: "chat-sidebar.log-message.capture-stopped",
    defaultMessage: "Capture stopped"
  },
  [LogMessageType.captureStarted]: {
    id: "chat-sidebar.log-message.capture-started",
    defaultMessage: "Capture started"
  },
  [LogMessageType.captureAlreadyStopped]: {
    id: "chat-sidebar.log-message.capture-already-stopped",
    defaultMessage: "Capture already stopped"
  },
  [LogMessageType.captureAlreadyRunning]: {
    id: "chat-sidebar.log-message.capture-already-running",
    defaultMessage: "Capture already running"
  },
  [LogMessageType.positionalAudioEnabled]: {
    id: "chat-sidebar.log-message.positional-audio-enabled",
    defaultMessage: "Positional audio enabled"
  },
  [LogMessageType.positionalAudioDisabled]: {
    id: "chat-sidebar.log-message.positional-audio-disabled",
    defaultMessage: "Positional audio disabled"
  },
  [LogMessageType.setAudioNormalizationFactor]: {
    id: "chat-sidebar.log-message.set-audio-normalization-factor",
    defaultMessage: "audioNormalization factor is set to {factor}"
  },
  [LogMessageType.audioNormalizationDisabled]: {
    id: "chat-sidebar.log-message.audio-normalization-disabled",
    defaultMessage: "audioNormalization is disabled"
  },
  [LogMessageType.audioNormalizationNaN]: {
    id: "chat-sidebar.log-message.audio-normalization-nan",
    defaultMessage: "audioNormalization command needs a valid number parameter"
  },
  [LogMessageType.invalidAudioNormalizationRange]: {
    id: "chat-sidebar.log-message.invalid-audio-normalization-range",
    defaultMessage:
      "audioNormalization command needs a base volume number between 0 [no normalization] and 255. Default is 0. The recommended value is 4, if you would like to enable normalization"
  },
  [LogMessageType.audioSuspended]: {
    id: "chat-sidebar.log-message.audio-suspended",
    defaultMessage: "Audio has been suspended, click somewhere in the Verse to resume the audio"
  },
  [LogMessageType.audioResumed]: {
    id: "chat-sidebar.log-message.audio-resumed",
    defaultMessage: "Audio has been resumed"
  },
  [LogMessageType.joinFailed]: {
    id: "chat-sidebar.log-message.join-failed",
    defaultMessage: "Failed to join room: {message}"
  },
  [LogMessageType.avatarChanged]: {
    id: "chat-sidebar.log-message.avatar-changed",
    defaultMessage: "Your avatar has been changed"
  },
  [LogMessageType.handRaised]: {
    id: "reaction-popover.hand-raised-warning",
    defaultMessage: "Has raised their hand"
  },
  [LogMessageType.voiceChatEnabled]: {
    id: "chat-sidebar.moderator-message.voice-chat-enabled",
    defaultMessage: "Voice chat has been turned on by a moderator"
  },
  [LogMessageType.voiceChatDisabled]: {
    id: "chat-sidebar.moderator-message.voice-chat-disabled",
    defaultMessage: "Voice chat has been turned off by a moderator"
  },
  [LogMessageType.voiceChatDisabledMod]: {
    id: "chat-sidebar.moderator-message.voice-chat-disabled-mod",
    defaultMessage: "Guests are unable to use voice chat"
  },
  [LogMessageType.textChatEnabled]: {
    id: "chat-sidebar.moderator-message.text-chat-enabled",
    defaultMessage: "Text chat has been turned on by a moderator"
  },
  [LogMessageType.textChatDisabled]: {
    id: "chat-sidebar.moderator-message.text-chat-disabled",
    defaultMessage: "Text chat has been turned off by a moderator"
  },
  [LogMessageType.textChatDisabledMod]: {
    id: "chat-sidebar.moderator-message.text-chat-disabled-mod",
    defaultMessage: "Guests are unable to send chat messages"
  },
  [LogMessageType.enteredVerse]: {
    id: "chat-sidebar.system-message.joined-room-log",
    defaultMessage: "Joined the Verse"
  },
  [LogMessageType.leaveVerse]: {
    id: "chat-sidebar.system-message.leave-log",
    defaultMessage: "Left the verse"
  },
  [LogMessageType.lobbyTip]: {
    id: "tips.lobby",
    defaultMessage: "You're in the lobby. Others cannot see or hear you."
  },
  [LogMessageType.lobbyCast]: {
    id: "tips.streaming",
    defaultMessage: "Now broadcasting to the lobby. Exit streamer mode in the more menu when you're done."
  },
  [LogMessageType.recordModeEnabled]: {
    id: "record-mode-enabled-tip",
    defaultMessage: "Record mode on, press 'B' to toggle off"
  },
  [LogMessageType.avatarCreated]: {
    id: "chat-sidebar.log-message.avatar-created",
    defaultMessage: "Avatar created successfully"
  },
  [LogMessageType.assetRenamed]: {
    id: "assets.rename-asset-success",
    defaultMessage: "Asset renamed successfully"
  },
  [LogMessageType.assetRenameFailed]: {
    id: "assets.rename-asset-failed",
    defaultMessage: "There was an error renaming the asset, please try again"
  },
  [LogMessageType.assetUpdated]: {
    id: "assets.update-asset-success",
    defaultMessage: "Asset updated successfully"
  },
  [LogMessageType.assetUpdateFailed]: {
    id: "assets.update-asset-failed",
    defaultMessage: "There was an error updating the asset, please try again"
  },
  [LogMessageType.assetDeleted]: {
    id: "assets.delete-asset-success",
    defaultMessage: "Asset deleted successfully"
  },
  [LogMessageType.assetDeleteFailed]: {
    id: "assets.delete-asset-failed",
    defaultMessage: "There was an error deleting the asset, please try again"
  },
  [LogMessageType.objectDeleted]: {
    id: "objects.delete-object-success",
    defaultMessage: "Object deleted successfully"
  },
  [LogMessageType.objectCloned]: {
    id: "objects.clone-object-success",
    defaultMessage: "Object cloned successfully"
  },
  [LogMessageType.copied]: {
    id: "copyable-text-input-field.copied-label",
    defaultMessage: "Copied to clipboard"
  },
  [LogMessageType.objectFocusedDeleted]: {
    id: "object-menu.object-focused-deleted-success",
    defaultMessage: "The object you were focusing on no longer exists"
  },
  [LogMessageType.assetOptimized]: {
    id: "assets.optimize-asset-success",
    defaultMessage: "Asset optimized successfully"
  },
  [LogMessageType.safariMicTitle]: {
    id: "safari-mic.title",
    defaultMessage: "Microphone access denied"
  },
  [LogMessageType.safariMicMessage]: {
    id: "safari-mic.message",
    defaultMessage: "Please reload the page and allow microphone permissions if you want to use audio features."
  }
});

export const enteredMessages = defineMessages({
  room: { id: "chat-sidebar.system-message.entered-room", defaultMessage: "{name} entered the Verse" },
  lobby: { id: "chat-sidebar.system-message.entered-lobby", defaultMessage: "{name} entered the lobby" }
});

export const logJoinedMessages = defineMessages({
  lobby: { id: "chat-sidebar.system-message.joined-lobby-log", defaultMessage: "Joined the lobby" },
  room: { id: "chat-sidebar.system-message.joined-room-log", defaultMessage: "Joined the Verse" }
});

export const joinedMessages = defineMessages({
  lobby: { id: "chat-sidebar.system-message.joined-lobby", defaultMessage: "{name} Joined the lobby" },
  room: { id: "chat-sidebar.system-message.joined-room", defaultMessage: "{name} joined the verse" }
});
